import template from './tb-spinner.html'
import './tb-spinner.scss'

const tbSpinner = { template }

export default tbSpinner
